import { ref, onMounted } from 'vue'
import { useIntervalFn } from '@vueuse/core' // Optional but recommended

interface VersionInfo {
  version: string
  timestamp: string
}

export function useVersionCheck(checkInterval = 1000 * 60 * 5) { // 5 minutes default
  const hasUpdate = ref(false)
  const lastBuild = ref<Timestamp>('')
  const currentVersion = ref<string>('')

  async function checkVersion() {
    try {
      const response = await fetch(new URL('/version.json', window.location.origin), { cache: 'no-cache' })
      const serverVersion: VersionInfo = await response.json()
      const { version, timestamp } = serverVersion

      // Set initial version
      if (!currentVersion.value) {
        currentVersion.value = version
        lastBuild.value = timestamp
        console.info('Running version', version)
        return
      }

      // Check if version differs
      if (version !== currentVersion.value) {
        console.log('New version available', version)
        hasUpdate.value = true
      }
    } catch (error) {
      console.error('Failed to check for updates:', error)
    }
  }

  onMounted(() => {
    // Registering useIntervalFn synchronously (rather than after an awaited
    // checkVersion()) keeps it inside the component's active effect scope, so
    // its interval is disposed automatically on unmount instead of leaking.
    useIntervalFn(checkVersion, checkInterval, { immediateCallback: true })
  })

  return {
    hasUpdate,
    currentVersion,
    lastBuild
  }
}
